import Drill from "../../../../../public/drill.svg";
import Hammer from "../../../../../public/hammer.svg";
import Home from "../../../../../public/home.svg";
import HVAC from "../../../../../public/HVAC.svg";
import Leaves from "../../../../../public/leaves.svg";
import Lightbulb from "../../../../../public/lightbulb.svg";
import PaintRoller from "../../../../../public/paint-roller.svg";
import Shovel from "../../../../../public/shovel.svg";
import Toilet from "../../../../../public/toilet.svg";

export const vendorColumns = [
  [
    {
      name: "Interior & exterior painting",
      Icon: PaintRoller
    },
    {
      name: "Renovations, big & small",
      Icon: Drill
    },
    {
      name: "General contractors",
      Icon: Hammer
    }
  ],
  [
    {
      name: "All-season lawn maintenace",
      Icon: Leaves
    },
    {
      name: "Electrical work",
      Icon: Lightbulb
    },
    {
      name: "Pool maintenance",
      Icon: Shovel
    }
  ],
  [
    {
      name: "HVAC",
      Icon: HVAC
    },
    {
      name: "Plumbing",
      Icon: Toilet
    },
    {
      name: "Whole-home maintenace",
      Icon: Home
    }
  ]
];

export const mobileVendorColumns = [
  [
    {
      name: "Interior & exterior painting",
      Icon: PaintRoller
    },
    {
      name: "Renovations, big & small",
      Icon: Drill
    },
    {
      name: "General contractors",
      Icon: Hammer
    },
    {
      name: "HVAC",
      Icon: HVAC
    }
  ],
  [
    {
      name: "All-season lawn maintenace",
      Icon: Leaves
    },
    {
      name: "Electrical work",
      Icon: Lightbulb
    },
    {
      name: "Pool maintenance",
      Icon: Shovel
    },
    {
      name: "Plumbing",
      Icon: Toilet
    }
  ]
];

export const wholeHomeMaintenance = {
  name: "Whole-home maintenace",
  Icon: Home
};
